/**
 * Translations object containing messages for different languages
 * @type {Object.<string, Object.<string, string>>}
 */
const translations = {
  en: {
    "Live predict": "Live predict",
    "Countdown minutes": "MIN",
    "Countdown seconds": "SEC",
    "Time remaining: {minutes}:{seconds}": "Time remaining: {minutes}:{seconds}",
    "Target price": "Target price",
    "Current price": "Current price",
    "Final price": "Final price",
    "Waiting for the target price": "Waiting for the target price",
    "Waiting for price data": "Waiting for price data",
    "Chart view": "Chart view",
    "Probability": "Probability",
    "BTC price": "BTC price",
    "Unable to load chart.": "Unable to load chart.",
    "Retry": "Retry",
    "Unable to confirm the result. Refresh the page to check your 2FA status.": "Unable to confirm the result. Refresh the page to check your 2FA status.",
    "Refresh page": "Refresh page",
    "Close": "Close",
    "Backup code character {position} of 8": "Backup code character {position} of 8",
    "Backup code": "Backup code",
    "Use a backup code": "Use a backup code",
    "Use an authenticator code": "Use an authenticator code",
    "Error sending request": "Error sending request",
    "Error": "Error",
    "Your progress": "Your progress",
    "Up to": "Up to",
    "From": "From",
    "Failed to load verification. Please refresh the page and try again.": "Failed to load verification. Please refresh the page and try again.",
    "Internal error occurred. Please try again.": "Internal error occurred. Please try again.",
    "Verification timed out. Please complete it again.": "Verification timed out. Please complete it again.",
    "Verification error. Please refresh the page or try again.": "Verification error. Please refresh the page or try again.",
    "Processing...": "Processing...",
    "Login error. Please try again.": "Login error. Please try again.",
    "Network error occurred. Please try again later.": "Network error occurred. Please try again later.",
    "Redirecting...": "Redirecting...",
    // Tournament-specific translations
    "coming soon": "coming soon",
    "ago": "ago",
    "from now": "from now",
    "Error loading tournaments. Please try again.": "Error loading tournaments. Please try again.",
    "There are no matches for selected filters": "There are no matches for selected filters",
    "Unable to apply filters. Please try again.": "Unable to apply filters. Please try again.",
    "Next Game": "Next Game",
    "Loading tournaments...": "Loading tournaments...",
    "Applying filters...": "Applying filters...",
    "Loading more tournaments...": "Loading more tournaments...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Football",
    "Basketball": "Basketball",
    "Hockey": "Hockey",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Other games",
    "Please select at least one item": "Please select at least one item",
    "In": "In",
    "Out": "Out",
    // Predictions-specific translations
    "You don't own any {team} shares for this outcome": "You don't own any {team} shares for this outcome",
    "You can only sell up to {maxQty} shares (your current position)": "You can only sell up to {maxQty} shares (your current position)",
    "Maximum bet amount is {maxValue} betcoins": "Maximum bet amount is {maxValue} betcoins",
    "Maximum bet amount is {maxValue} betcoins (≈{maxShares} shares at ${price}/share)": "Maximum bet amount is {maxValue} betcoins (≈{maxShares} shares at ${price}/share)",
    "Maximum bet amount is {maxValue} betcoins (market order)": "Maximum bet amount is {maxValue} betcoins (market order)",
    "Maximum sellable amount is {maxValue}": "Maximum sellable amount is {maxValue}",
    "Minimum amount is {minValue}": "Minimum amount is {minValue}",
    "Price must be between $0.01 and $0.99": "Price must be between $0.01 and $0.99",
    "No position": "No position",
    "No orders": "No orders",
    "No data": "No data",
    "No sellers available in order book": "No sellers available in order book",
    "No buyers available in order book": "No buyers available in order book",
    "Only {filledQty} of {totalQty} shares can be filled": "Only {filledQty} of {totalQty} shares can be filled",
    "Only ${filledValue} of ${totalValue} can be filled": "Only ${filledValue} of ${totalValue} can be filled",
    "Warning: {error}": "Warning: {error}",
    "Invalid parameters for market sell": "Invalid parameters for market sell",
    "Invalid parameters for market buy": "Invalid parameters for market buy",
    "no liquidity": "no liquidity",
    "partial": "partial",
    "Avg buy price:": "Avg buy price:",
    "Avg sell price:": "Avg sell price:",
    "You have {count} order(s) at this price ({teams})": "You have {count} order(s) at this price ({teams})",
    " - {qty} shares": " - {qty} shares",
    "Last:": "Last:",
    "Spread:": "Spread:",
    "No asks": "No asks",
    "No bids": "No bids",
    "An error occurred while placing your bet.": "An error occurred while placing your bet.",
    "Invalid bet parameters. Please check your input.": "Invalid bet parameters. Please check your input.",
    "Please log in to place bets.": "Please log in to place bets.",
    "You are not allowed to place this bet.": "You are not allowed to place this bet.",
    "Too many requests. Please wait before placing another bet.": "Too many requests. Please wait before placing another bet.",
    "Server error. Please try again later.": "Server error. Please try again later.",
    "buy": "buy",
    "sell": "sell",
    "YES": "YES",
    "NO": "NO",
    // Add more English translations here
  },
  ru: {
    "Live predict": "Live predict",
    "Countdown minutes": "МИН",
    "Countdown seconds": "СЕК",
    "Time remaining: {minutes}:{seconds}": "До конца: {minutes}:{seconds}",
    "Target price": "Целевая цена",
    "Current price": "Текущая цена",
    "Final price": "Итоговая цена",
    "Waiting for the target price": "Ожидаем фиксацию стартовой цены",
    "Waiting for price data": "Ожидаем данные цены",
    "Chart view": "Вид графика",
    "Probability": "Вероятность",
    "BTC price": "Цена BTC",
    "Unable to load chart.": "Не удалось загрузить график.",
    "Retry": "Повторить",
    "Unable to confirm the result. Refresh the page to check your 2FA status.": "Не удалось подтвердить результат. Обновите страницу, чтобы проверить состояние 2FA.",
    "Refresh page": "Обновить страницу",
    "Close": "Закрыть",
    "Backup code character {position} of 8": "Символ резервного кода {position} из 8",
    "Backup code": "Резервный код",
    "Use a backup code": "Использовать резервный код",
    "Use an authenticator code": "Использовать код из приложения",
    "Error sending request": "Ошибка отправки запроса",
    "Error": "Ошибка",
    "Your progress": "Ваш прогресс",
    "Up to": "До",
    "From": "От",
    "Failed to load verification. Please refresh the page and try again.": "Не удалось загрузить проверку. Обновите страницу и попробуйте снова.",
    "Internal error occurred. Please try again.": "Произошла внутренняя ошибка. Пожалуйста, попробуйте снова.",
    "Verification timed out. Please complete it again.": "Время проверки истекло. Пожалуйста, пройдите ее снова.",
    "Verification error. Please refresh the page or try again.": "Ошибка при проверке. Попробуйте обновить страницу или повторить попытку.",
    "Processing...": "Обработка...",
    "Login error. Please try again.": "Ошибка входа. Попробуйте снова.",
    "Network error occurred. Please try again later.": "Произошла ошибка сети. Пожалуйста, попробуйте позже.",
    "Redirecting...": "Перенаправление...",
    // Tournament-specific translations
    "coming soon": "скоро начало",
    "ago": "идет",
    "from now": "до начала",
    "Error loading tournaments. Please try again.": "Ошибка загрузки турниров. Попробуйте еще раз.",
    "There are no matches for selected filters": "Нет матчей для выбранных фильтров",
    "Unable to apply filters. Please try again.": "Не удалось применить фильтры. Попробуйте еще раз.",
    "Next Game": "Следующая игра",
    "Loading tournaments...": "Загрузка турниров...",
    "Applying filters...": "Применение фильтров...",
    "Loading more tournaments...": "Загрузка дополнительных турниров...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Футбол",
    "Basketball": "Баскетбол",
    "Hockey": "Хоккей",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Другие игры",
    "Please select at least one item": "Пожалуйста, выберите хотя бы один предмет",
    "In": "Внесено",
    "Out": "Получено",
    // Predictions-specific translations
    "You don't own any {team} shares for this outcome": "У вас нет долей «{team}» для этого исхода",
    "You can only sell up to {maxQty} shares (your current position)": "Вы можете продать максимум {maxQty} долей (ваша текущая позиция)",
    "Maximum bet amount is {maxValue} betcoins": "Максимальная сумма ставки {maxValue} беткоинов",
    "Maximum bet amount is {maxValue} betcoins (≈{maxShares} shares at ${price}/share)": "Максимальная сумма ставки {maxValue} беткоинов (≈{maxShares} долей по ${price}/доля)",
    "Maximum bet amount is {maxValue} betcoins (market order)": "Максимальная сумма ставки {maxValue} беткоинов (рыночный ордер)",
    "Maximum sellable amount is {maxValue}": "Максимальная сумма для продажи {maxValue}",
    "Minimum amount is {minValue}": "Минимальная сумма {minValue}",
    "Price must be between $0.01 and $0.99": "Цена должна быть от $0.01 до $0.99",
    "No position": "Нет позиции",
    "No orders": "Нет ордеров",
    "No data": "Нет данных",
    "No sellers available in order book": "Нет продавцов в книге ордеров",
    "No buyers available in order book": "Нет покупателей в книге ордеров",
    "Only {filledQty} of {totalQty} shares can be filled": "Можно исполнить только {filledQty} из {totalQty} долей",
    "Only ${filledValue} of ${totalValue} can be filled": "Можно исполнить только ${filledValue} из ${totalValue}",
    "Warning: {error}": "Предупреждение: {error}",
    "Invalid parameters for market sell": "Неверные параметры для рыночной продажи",
    "Invalid parameters for market buy": "Неверные параметры для рыночной покупки",
    "no liquidity": "нет ликвидности",
    "partial": "частично",
    "Avg buy price:": "Средняя цена покупки:",
    "Avg sell price:": "Средняя цена продажи:",
    "You have {count} order(s) at this price ({teams})": "У вас {count} ордер(ов) по этой цене ({teams})",
    " - {qty} shares": " - {qty} долей",
    "Last:": "Последняя:",
    "Spread:": "Спред:",
    "No asks": "Нет предложений",
    "No bids": "Нет заявок",
    "An error occurred while placing your bet.": "Произошла ошибка при размещении ставки.",
    "Invalid bet parameters. Please check your input.": "Неверные параметры ставки. Проверьте ввод.",
    "Please log in to place bets.": "Войдите в систему для размещения ставок.",
    "You are not allowed to place this bet.": "Вам не разрешено размещать эту ставку.",
    "Too many requests. Please wait before placing another bet.": "Слишком много запросов. Подождите перед размещением следующей ставки.",
    "Server error. Please try again later.": "Ошибка сервера. Попробуйте позже.",
    "buy": "покупка",
    "sell": "продажа",
    "YES": "ДА",
    "NO": "НЕТ",
    // Add more Russian translations here
  },
  uk: {
    "Live predict": "Live predict",
    "Countdown minutes": "ХВ",
    "Countdown seconds": "СЕК",
    "Time remaining: {minutes}:{seconds}": "До кінця: {minutes}:{seconds}",
    "Target price": "Цільова ціна",
    "Current price": "Поточна ціна",
    "Final price": "Підсумкова ціна",
    "Waiting for the target price": "Очікуємо фіксацію стартової ціни",
    "Waiting for price data": "Очікуємо дані ціни",
    "Chart view": "Вигляд графіка",
    "Probability": "Імовірність",
    "BTC price": "Ціна BTC",
    "Unable to load chart.": "Не вдалося завантажити графік.",
    "Retry": "Повторити",
    "Unable to confirm the result. Refresh the page to check your 2FA status.": "Не вдалося підтвердити результат. Оновіть сторінку, щоб перевірити стан 2FA.",
    "Refresh page": "Оновити сторінку",
    "Close": "Закрити",
    "Backup code character {position} of 8": "Символ резервного коду {position} із 8",
    "Backup code": "Резервний код",
    "Use a backup code": "Використати резервний код",
    "Use an authenticator code": "Використати код із застосунку",
    "Error sending request": "Помилка надсилання запиту",
    "Error": "Помилка",
    "Your progress": "Ваш прогрес",
    "Up to": "До",
    "From": "Від",
    "Failed to load verification. Please refresh the page and try again.": "Не вдалося завантажити перевірку. Оновіть сторінку і спробуйте ще раз.",
    "Internal error occurred. Please try again.": "Виникла внутрішня помилка. Будь ласка, спробуйте ще раз.",
    "Verification timed out. Please complete it again.": "Час перевірки минув. Будь ласка, пройдіть її ще раз.",
    "Verification error. Please refresh the page or try again.": "Помилка перевірки. Оновіть сторінку або спробуйте ще раз.",
    "Processing...": "Обробка...",
    "Login error. Please try again.": "Помилка входу. Спробуйте ще раз.",
    "Network error occurred. Please try again later.": "Виникла помилка мережі. Будь ласка, спробуйте пізніше.",
    "Redirecting...": "Перенаправлення...",
    // Tournament-specific translations
    "coming soon": "скоро початок",
    "ago": "триває",
    "from now": "до початку",
    "Error loading tournaments. Please try again.": "Помилка завантаження турнірів. Спробуйте ще раз.",
    "There are no matches for selected filters": "Немає матчів для вибраних фільтрів",
    "Unable to apply filters. Please try again.": "Не вдалося застосувати фільтри. Спробуйте ще раз.",
    "Next Game": "Наступна гра",
    "Loading tournaments...": "Завантаження турнірів...",
    "Applying filters...": "Застосування фільтрів...",
    "Loading more tournaments...": "Завантаження додаткових турнірів...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Футбол",
    "Basketball": "Баскетбол",
    "Hockey": "Хокей",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Інші ігри",
    "Please select at least one item": "Будь ласка, виберіть хоча б один предмет",
    "In": "Внесено",
    "Out": "Отримано",
    // Predictions-specific translations
    "You don't own any {team} shares for this outcome": "У вас немає часток «{team}» для цього результату",
    "You can only sell up to {maxQty} shares (your current position)": "Ви можете продати максимум {maxQty} часток (ваша поточна позиція)",
    "Maximum bet amount is {maxValue} betcoins": "Максимальна сума ставки {maxValue} беткоїнів",
    "Maximum bet amount is {maxValue} betcoins (≈{maxShares} shares at ${price}/share)": "Максимальна сума ставки {maxValue} беткоїнів (≈{maxShares} часток по ${price}/частка)",
    "Maximum bet amount is {maxValue} betcoins (market order)": "Максимальна сума ставки {maxValue} беткоїнів (ринковий ордер)",
    "Maximum sellable amount is {maxValue}": "Максимальна сума для продажу {maxValue}",
    "Minimum amount is {minValue}": "Мінімальна сума {minValue}",
    "Price must be between $0.01 and $0.99": "Ціна повинна бути від $0.01 до $0.99",
    "No position": "Немає позиції",
    "No orders": "Немає ордерів",
    "No data": "Немає даних",
    "No sellers available in order book": "Немає продавців у книзі ордерів",
    "No buyers available in order book": "Немає покупців у книзі ордерів",
    "Only {filledQty} of {totalQty} shares can be filled": "Можна виконати тільки {filledQty} з {totalQty} часток",
    "Only ${filledValue} of ${totalValue} can be filled": "Можна виконати тільки ${filledValue} з ${totalValue}",
    "Warning: {error}": "Попередження: {error}",
    "Invalid parameters for market sell": "Неправильні параметри для ринкового продажу",
    "Invalid parameters for market buy": "Неправильні параметри для ринкової покупки",
    "no liquidity": "немає ліквідності",
    "partial": "частково",
    "Avg buy price:": "Середня ціна покупки:",
    "Avg sell price:": "Середня ціна продажу:",
    "You have {count} order(s) at this price ({teams})": "У вас {count} ордер(ів) за цією ціною ({teams})",
    " - {qty} shares": " - {qty} часток",
    "Last:": "Остання:",
    "Spread:": "Спред:",
    "No asks": "Немає пропозицій",
    "No bids": "Немає заявок",
    "An error occurred while placing your bet.": "Сталася помилка при розміщенні ставки.",
    "Invalid bet parameters. Please check your input.": "Неправильні параметри ставки. Перевірте введення.",
    "Please log in to place bets.": "Увійдіть у систему для розміщення ставок.",
    "You are not allowed to place this bet.": "Вам не дозволено розміщувати цю ставку.",
    "Too many requests. Please wait before placing another bet.": "Забагато запитів. Зачекайте перед розміщенням наступної ставки.",
    "Server error. Please try again later.": "Помилка сервера. Спробуйте пізніше.",
    "buy": "покупка",
    "sell": "продаж",
    "YES": "ТАК",
    "NO": "НІ",
    // Add more Ukrainian translations here
  },
  es: {
    "Live predict": "Live predict",
    "Countdown minutes": "MIN",
    "Countdown seconds": "SEG",
    "Time remaining: {minutes}:{seconds}": "Tiempo restante: {minutes}:{seconds}",
    "Target price": "Precio objetivo",
    "Current price": "Precio actual",
    "Final price": "Precio final",
    "Waiting for the target price": "Esperando el precio objetivo",
    "Waiting for price data": "Esperando datos del precio",
    "Chart view": "Vista del gráfico",
    "Probability": "Probabilidad",
    "BTC price": "Precio de BTC",
    "Unable to load chart.": "No se pudo cargar el gráfico.",
    "Retry": "Reintentar",
    "Unable to confirm the result. Refresh the page to check your 2FA status.": "No se pudo confirmar el resultado. Actualiza la página para comprobar el estado de la autenticación de dos factores.",
    "Refresh page": "Actualizar página",
    "Close": "Cerrar",
    "Backup code character {position} of 8": "Carácter {position} de 8 del código de respaldo",
    "Backup code": "Código de respaldo",
    "Use a backup code": "Usar un código de respaldo",
    "Use an authenticator code": "Usar un código de la aplicación",
    "Error sending request": "Error al enviar la solicitud",
    "Error": "Error",
    "Your progress": "Tu progreso",
    "Up to": "Hasta",
    "From": "Desde",
    "Failed to load verification. Please refresh the page and try again.": "No se pudo cargar la verificación. Actualiza la página e inténtalo de nuevo.",
    "Internal error occurred. Please try again.": "Ocurrió un error interno. Por favor, inténtalo de nuevo.",
    "Verification timed out. Please complete it again.": "El tiempo de verificación ha expirado. Por favor, complétala de nuevo.",
    "Verification error. Please refresh the page or try again.": "Error de verificación. Actualiza la página o inténtalo de nuevo.",
    "Processing...": "Procesando...",
    "Login error. Please try again.": "Error de inicio de sesión. Inténtalo de nuevo.",
    "Network error occurred. Please try again later.": "Ocurrió un error de red. Por favor, inténtalo más tarde.",
    "Redirecting...": "Redirigiendo...",
    // Tournament-specific translations
    "coming soon": "próximamente",
    "ago": "hace",
    "from now": "a partir de ahora",
    "Error loading tournaments. Please try again.": "Error al cargar torneos. Inténtalo de nuevo.",
    "There are no matches for selected filters": "No hay partidos para los filtros seleccionados",
    "Unable to apply filters. Please try again.": "No se pudieron aplicar los filtros. Inténtalo de nuevo.",
    "Next Game": "Próximo Juego",
    "Loading tournaments...": "Cargando torneos...",
    "Applying filters...": "Aplicando filtros...",
    "Loading more tournaments...": "Cargando más torneos...",
    "Dota 2": "Dota 2",
    "CS 2": "CS 2",
    "Overwatch": "Overwatch",
    "Hearthstone": "Hearthstone",
    "Football": "Fútbol",
    "Basketball": "Baloncesto",
    "Hockey": "Hockey",
    "League of Legends": "League of Legends",
    "StarCraft": "StarCraft",
    "Valorant": "Valorant",
    "Other games": "Otros juegos",
    "Please select at least one item": "Por favor, seleccione al menos un elemento",
    "In": "Contribuido",
    "Out": "Recibió",
    // Predictions-specific translations
    "You don't own any {team} shares for this outcome": "No tienes acciones «{team}» para este resultado",
    "You can only sell up to {maxQty} shares (your current position)": "Solo puedes vender hasta {maxQty} acciones (tu posición actual)",
    "Maximum bet amount is {maxValue} betcoins": "La cantidad máxima de apuesta es {maxValue} betcoins",
    "Maximum bet amount is {maxValue} betcoins (≈{maxShares} shares at ${price}/share)": "La cantidad máxima de apuesta es {maxValue} betcoins (≈{maxShares} acciones a ${price}/acción)",
    "Maximum bet amount is {maxValue} betcoins (market order)": "La cantidad máxima de apuesta es {maxValue} betcoins (orden de mercado)",
    "Maximum sellable amount is {maxValue}": "La cantidad máxima vendible es {maxValue}",
    "Minimum amount is {minValue}": "La cantidad mínima es {minValue}",
    "Price must be between $0.01 and $0.99": "El precio debe estar entre $0.01 y $0.99",
    "No position": "Sin posición",
    "No orders": "Sin órdenes",
    "No data": "Sin datos",
    "No sellers available in order book": "No hay vendedores disponibles en el libro de órdenes",
    "No buyers available in order book": "No hay compradores disponibles en el libro de órdenes",
    "Only {filledQty} of {totalQty} shares can be filled": "Solo se pueden llenar {filledQty} de {totalQty} acciones",
    "Only ${filledValue} of ${totalValue} can be filled": "Solo se puede llenar ${filledValue} de ${totalValue}",
    "Warning: {error}": "Advertencia: {error}",
    "Invalid parameters for market sell": "Parámetros inválidos para venta de mercado",
    "Invalid parameters for market buy": "Parámetros inválidos para compra de mercado",
    "no liquidity": "sin liquidez",
    "partial": "parcial",
    "Avg buy price:": "Precio promedio de compra:",
    "Avg sell price:": "Precio promedio de venta:",
    "You have {count} order(s) at this price ({teams})": "Tienes {count} orden(es) a este precio ({teams})",
    " - {qty} shares": " - {qty} acciones",
    "Last:": "Última:",
    "Spread:": "Diferencial:",
    "No asks": "Sin ofertas",
    "No bids": "Sin pujas",
    "An error occurred while placing your bet.": "Ocurrió un error al colocar tu apuesta.",
    "Invalid bet parameters. Please check your input.": "Parámetros de apuesta inválidos. Verifica tu entrada.",
    "Please log in to place bets.": "Inicia sesión para realizar apuestas.",
    "You are not allowed to place this bet.": "No tienes permitido realizar esta apuesta.",
    "Too many requests. Please wait before placing another bet.": "Demasiadas solicitudes. Espera antes de realizar otra apuesta.",
    "Server error. Please try again later.": "Error del servidor. Inténtalo más tarde.",
    "buy": "compra",
    "sell": "venta",
    "YES": "SÍ",
    "NO": "NO",
    // Add more Spanish translations here
  },
};

/**
 * Get the current language from the html's lang attribute
 * @returns {string} The current language code (ISO 639-1)
 */
export function getCurrentLanguage() {
  const fullLocale = document.documentElement.lang || 'en';
  return fullLocale.split('-')[0].toLowerCase();
}

/**
 * Maps ISO 639-1 language codes to URL prefixes used in the application
 * Ukrainian uses "ua" in URLs instead of ISO code "uk"
 * @param {string} langCode - ISO 639-1 language code (e.g., 'en', 'ru', 'uk', 'es')
 * @returns {string} URL prefix for the language
 */
export function getLanguageUrlPrefix(langCode = null) {
  const lang = langCode || getCurrentLanguage();

  const langToUrlPrefix = {
    'uk': 'ua',
    'ru': 'ru',
    'en': 'en',
    'es': 'es'
  };

  return langToUrlPrefix[lang] || lang;
}

/**
 * Translate a message to the current language
 * @param {string} message - The message to translate
 * @param {Object} variables - Variables to substitute in the translation (e.g., {team: 'YES', maxQty: 10})
 * @returns {string} The translated message or the original message if no translation is found
 */
export function translate(message, variables = {}) {
  // Return empty string if message is undefined or empty
  if (message === undefined || message === '') {
    return '';
  }
  
  const lang = getCurrentLanguage();
  
  if (!Object.prototype.hasOwnProperty.call(translations, lang)) {
    console.warn(`Translation not available for language: ${lang}`);
    return substituteVariables(translations['en'][message] || message, variables);
  }
  
  const translatedMessage = translations[lang][message] || translations['en'][message] || message;
  return substituteVariables(translatedMessage, variables);
}

/**
 * Substitute variables in a translated message
 * @param {string} message - The message with placeholders like {variableName}
 * @param {Object} variables - Object with variable values
 * @returns {string} Message with variables substituted
 */
function substituteVariables(message, variables) {
  if (!variables || typeof variables !== 'object') {
    return message;
  }
  
  return message.replace(/\{(\w+)\}/g, (match, key) => {
    return variables[key] !== undefined ? variables[key] : match;
  });
}

/**
 * Set the current language
 * @param {string} lang - The ISO 639-1 language code (e.g., 'en', 'es')
 * @throws {Error} If the provided language code is invalid
 */
export function setLanguage(lang) {
  if (typeof lang !== 'string' || !/^[a-z]{2}$/.test(lang)) {
    throw new Error('Invalid language code. Please use ISO 639-1 format (e.g., en, es)');
  }
  document.documentElement.lang = lang;
}
